import { TableUI } from "components/design/TableUI";
import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "react-table-8.10.7";
import { CallDetail } from "types/Models/broadcastCall";

const createColumn = createColumnHelper<CallDetail>();

const columns = [
  createColumn.accessor("team_member_name", {
    header: "CUSTOMER",
    size: 30,
    cell: (info) => (
      <div className="t-flex t-items-center t-gap-2">
        <Avatar alt={info.getValue()} variant="primary" />
        <div className="t-text-body-sm t-text-text-60 t-line-clamp-1">
          {info.getValue()}
        </div>
      </div>
    ),
  }),
  createColumn.accessor("entity_name", {
    header: "ENTITY",
    size: 40,
    cell: (info) => (
      <div className="t-text-body-sm t-text-text-60 t-line-clamp-1 t-py-1">
        {info.getValue()}
      </div>
    ),
  }),
  createColumn.accessor("mobile_number", {
    header: "PHONE NUMBER",
    size: 20,
    cell: (info) => (
      <div className="t-text-body-sm t-text-text-30 t-line-clamp-1">
        {info.getValue()}
      </div>
    ),
  }),
];
export const BroadcastCallChannelList = ({
  userDetails,
}: {
  userDetails: CallDetail[];
}) => {
  const table = useReactTable({
    data: userDetails,
    columns: columns,
    getCoreRowModel: getCoreRowModel(),
  });
  return <TableUI table={table} height="240px" />;
};
